import * as actionTypes from "./actionTypes";
import { auth, api } from "../../common/api-utils";
import { pathOr } from "ramda";
import { toast } from "react-toastify";
import { dispatch } from "d3";

const loginRequest = () => ({
  type: actionTypes.LOGIN_REQUEST,
});

export const loginSuccess = (payload) => ({
  type: actionTypes.LOGIN_SUCCESS,
  payload,
});

const loginFailure = (error) => ({
  type: actionTypes.LOGIN_FAILURE,
  error,
});

export const clearLoginError = () => ({
  type: actionTypes.CLEAR_LOGIN_ERROR,
});

export const login = (payload) => async (dispatch) => {
  try {
    dispatch(loginRequest());
    var qs = require("qs");
    auth.setHeader("Content-Type", "application/x-www-form-urlencoded");
    const res = await auth.post("/access_token",  qs.stringify(payload));
    if (res.ok) {
      api.setHeader("Authorization", res.data.access_token);
      dispatch(loginSuccess(res.data));
      toast("Welcome...");
      return;
    }
    dispatch(
      loginFailure(pathOr("Something went wrong!", ["data", "message"], res)),
    );
    toast(pathOr("Something went wrong!", ["data", "message"], res),{autoClose : 5000});
  } catch (e) {
    toast("Something went wrong!",{autoClose : 5000});
    dispatch(loginFailure(e));
  }
};

const forgotRequest = () => ({
  type: actionTypes.FORGOT_REQUEST,
});

const forgotSuccess = (payload) => ({
  type: actionTypes.FORGOT_SUCCESS,
  payload,
});

const forgotFailure = (error) => ({
  type: actionTypes.FORGOT_FAILURE,
  error,
});

export const forgot = (payload) => async (dispatch) =>{
  console.log(payload);
  //console.log(payload.url);
  // var url = `/meta/sentPasswordLink`;
  // delete payload["url"];
  // payload["linkid"] = "123";
  // payload["newpassword"] = "test";
  // payload['emailurl'] = window.location.protocol+"//"+window.location.host;
  //payload = JSON.stringify(payload);
  //console.log(payload,"after stringify");
  try {
    payload=JSON.stringify(payload);
    dispatch(forgotRequest());
    const res = await auth.post("/meta/sentPasswordLink", payload);
    if (res.ok) {
      //api.setHeader("Authorization", res.data.access_token);
      dispatch(forgotSuccess(res.data));
      toast(res.data.data.message);
      return;
    }
    dispatch(
      forgotFailure(pathOr("Something went wrong!", ["data", "message"], res)),
    );
    toast(pathOr("Something went wrong!", ["data", "message"], res),{autoClose : 5000});
  } catch (e) {
    toast("Something went wrong!",{autoClose : 5000});
    dispatch(forgotFailure(e));
  }

}

const resetRequest = () => ({
  type: actionTypes.RESET_REQUEST,
});

const resetSuccess = (payload) => ({
  type: actionTypes.RESET_SUCCESS,
  payload,
});

const resetFailure = (error) => ({
  type: actionTypes.RESET_FAILURE,
  error,
});

export const reset = (payload) => async (dispatch) =>{
  const queryParams = new URLSearchParams(window.location.search);
  const ids = queryParams.get('id');

  var currentURL = window.location.hostname + window.location.pathname ;
  var url = `${payload.url}/meta/resetPassword`;
  console.log(url);
  delete payload["newconfirmpassword"];
  delete payload["url"];
  payload["linkid"] = ids;
  payload = JSON.stringify(payload);
  try {
    dispatch(resetRequest());
    const res = await auth.post(url,  payload);
    console.log(res);
    if (res.ok) {
      dispatch(resetSuccess(res.data));
      toast(res.data.data.message);
      return;
    }
    dispatch(
      resetFailure(pathOr("Something went wrong!", ["data", "message"], res)),
    );
    toast(pathOr("Something went wrong!", ["data", "message"], res),{autoClose : 5000});
  } catch (e) {
    toast("Something went wrong!",{autoClose : 5000});
    dispatch(resetFailure(e));
  }
}

const logoutRequest = () => ({
  type: actionTypes.LOGOUT_REQUEST,
});

const logoutSuccess = () => ({
  type: actionTypes.LOGOUT_SUCCESS,
});

const logoutFailure = (error) => ({
  type: actionTypes.LOGOUT_FAILURE,
  error,
});

export const forceLogout = () => ({
  type: actionTypes.FORCE_LOGOUT,
});

export const logout = () => async (dispatch) => {
  try {
    dispatch(logoutRequest());
    const res = await api.post("/V8/logout");
    if (res.ok) {
      dispatch(logoutSuccess());
      dispatch(resetStore());
      return;
    }
    dispatch(loginFailure(res.data.message));
  } catch (e) {
    dispatch(logoutFailure(e));
  }
};


const logoRequest = () => ({
  type: actionTypes.LOGO_REQUEST,
});

const logoSuccess = () => ({
  type: actionTypes.LOGO_SUCCESS,
});

const logoFailure = (error) => ({
  type: actionTypes.LOGO_FAILURE,
  error,
});

export const getMetaAssets =(params)=> async (dispatch) => {
  try {
    // dispatch(logoRequest());
    const res= await auth.post("/logo",params);
    if(res.ok){
      // dispatch(logoSuccess(res.data));

      return res.data;
    }
  } catch (ex) {
    // dispatch(logoFailure(ex));

    return ex;
  }
};

export const resetStore = () => ({
  type: actionTypes.RESET_STORE,
});
